module.exports = __webpack_public_path__ + "img/TSM_cahora.28cfa454.jpg";